import { useMutation } from '@apollo/client';
import { Stack } from '@fluentui/react';
import { ActionMessageModal } from 'common/components/ActionMessageModal';
import { cutToast } from 'utility/toast';
import { EntityType } from 'common/types/utility';
import Decimal from 'decimal.js';
import React from 'react';
import { useHistory } from 'react-router-dom';

import {
  TravelAuthorizationDelete,
  TravelAuthorizationDeleteVariables,
} from 'travelAuthorization/TravelPlan/__generated__/TravelAuthorizationDelete';
import { TravelAuthorization_travelAuthorization } from 'travelAuthorization/TravelPlan/view/__generated__/TravelAuthorization';
import DELETE_AUTH from '../../../../TravelAuthorizationDelete.graphql';

interface DeleteTraveAuthProps {
  isNew: boolean;
  disabled?: boolean;
  travelAuthorizationData:
    | TravelAuthorization_travelAuthorization
    | null
    | undefined;
}
export const DeleteTraveAuth: React.FC<DeleteTraveAuthProps> = ({
  travelAuthorizationData,
  isNew,
  disabled = false,
}) => {
  const history = useHistory();
  const [deleteAuth] = useMutation<
    TravelAuthorizationDelete,
    TravelAuthorizationDeleteVariables
  >(DELETE_AUTH);

  const onConfirm = async () => {
    const { errors } = await deleteAuth({
      variables: {
        input: {
          entityDelete: [
            {
              id: travelAuthorizationData?.id!,
              rowTimestamp: travelAuthorizationData?._rowTimestamp!,
            },
          ],
        },
      },
      update: (cache, { data }) => {
        if (data?.travelAuthorizationDelete?.deletedEntities?.length) {
          const identity = cache.identify({
            ...travelAuthorizationData,
          });
          cache.evict({ id: identity });
          cache.gc();
          cache.modify({
            fields: {
              travelAuthorizationSearchFilterTotals: (existingData) => {
                return {
                  ...existingData,
                  totalCount1: Number(existingData.totalCount1) - 1,
                  totalAmount1: new Decimal(existingData.totalAmount1)
                    .minus(travelAuthorizationData?.controlTotalAmount || '0')
                    .toNumber(),
                };
              },
            },
          });
        }
      },
    });

    if (errors?.length) cutToast.error(errors[0].message);
    else {
      cutToast.success('Record Deleted Successfully');
      history.replace('/ta/travel-plan');
    }
  };

  return (
    <Stack>
      {!isNew && (
        <ActionMessageModal
          visible={!isNew}
          entityType={EntityType.TravelPlan}
          disabled={disabled}
          onConfirm={onConfirm}
        />
      )}
    </Stack>
  );
};
